import React from 'react';
import { BsCart2 } from 'react-icons/bs';
import { FiLogOut } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import useOrder from '../../hooks/useOrder';

const AuthorizeUser = () => {
  const { user, signOutUser } = useAuth();
  const { orders } = useOrder();
  const navigate = useNavigate();

  const userName = user?.name || user?.displayName;
  const userPhoto = user?.photoURL;

  return (
    <>
      {userName ? (
        <div className="flex items-center justify-end space-x-6">
          <div className="relative cursor-pointer" onClick={() => navigate('/orders')}>
            <span className="bg-paragaia w-6 h-6 rounded-full flex items-center justify-center text-white text-xs absolute -right-2 -top-2">
              {Array.isArray(orders)
                ? orders.reduce((sum, item) => sum + (item.quantity || 0), 0)
                : 0}
            </span>
            <BsCart2 className="w-6 h-6 text-paragaia" />
          </div>

          <p className="text-paragaia poppins hidden md:block">{userName}</p>

          <img
            src={userPhoto || "https://res.cloudinary.com/dfqozoox8/image/upload/v1752454345/team_v65npd.png"}
            alt={userName || "Avatar"}
            className="w-10 h-10 rounded-full object-cover"
          />

          <FiLogOut
            className="cursor-pointer w-6 h-6 text-paragaia hover:text-paragaiaLight transition"
            onClick={() => signOutUser('[Navbar] Manual logout')}
          />
        </div>
      ) : (
        <div className="flex items-center justify-end space-x-6">
          <button
            className="poppins text-paragaia text-lg hover:underline"
            onClick={() => navigate('/signin')}
          >
            Connexion
          </button>
          <button
            className="bg-paragaia text-white px-6 py-3 rounded-full poppins hover:bg-paragaiaLight transition"
            onClick={() => navigate('/signup')}
          >
            Créer un compte
          </button>
        </div>
      )}
    </>
  );
};

export default AuthorizeUser;
